<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18NacZK/tc-custom/9781452126920.jpg?1700681929595" alt="This image is the cover for the book Beer Makes Daddy Strong"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beer Makes Daddy Strong
      </h1>
      <p class="bookDescription body article font2">
        <b>This collection of comics from the author of <i>Wine Makes Mommy Clever</i> and <i>Dawn of the Bunny Suicides</i> takes a humorous look at fatherhood in all its glory.</b><br/><br/>Fatherhood is full of ups and downs, quirks and crises. But there is always humor to be found! Featuring 60 all-new cartoons from Andy Riley, <i>Beer Makes Daddy Strong</i> shows the world just how great dads can be: Daddy knows all the best car games (“Who can stay quiet the longest?”), likes to show off his scars (that he may or may not have obtained while running with the bulls in Spain), and is a great cook (when Spaghetti Bolognese is on the menu). Witty and wise, this affectionate tribute is a celebration of fatherhood and all of its joys, confusion, humor, and, of course, beer.<br/><br/><b>Praise for <i>Beer Makes Daddy Strong</i></b><br/><br/>“This will make you laugh. It is a piece of artwork, really; a collection of cartoons capturing those “dad moments” that can be humiliating, embarrassing or just plain stupid.” —<i>The Daily Telegraph</i> (UK)<br/><br/>“Laugh-out-loud tour through life as a first, from the first ultrasound to holiday traffic jams and pipe and slippers time.” —<i>News of the World</i> (UK)<br/><br/>“Funny, true, and—speaking as a dad—embarrassingly accurate.” —Chris Addison
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andy Riley
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?40b438a9